import {
  ChangeDetectionStrategy,
  Component, Inject, Input, OnDestroy, OnInit,
} from '@angular/core';
import {bzIconMaximizeView, bzIconMinimizeView} from '@bringoz/ui/icons';
import {Subscription} from "rxjs";
import {SiteNavMenuService} from "../../services/site-nav-menu.service";


require('./bringoz-site-nav-toggle.scss');
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'app-bringoz-site-nav-toggle',
  templateUrl: './bringoz-site-nav-toggle.html',
})
export class BringozSiteNavToggleComponent implements OnInit, OnDestroy {

  readonly icons = {maximize: bzIconMaximizeView, minimize: bzIconMinimizeView};

  @Input() isDisabled: boolean;

  public isShow: boolean;
  public siteNavMenuSubscription: Subscription;

  constructor(@Inject(SiteNavMenuService) private siteNavMenuService: SiteNavMenuService) {
  }

  ngOnInit() {
    this.siteNavMenuSubscription = this.siteNavMenuService.getIsEnabled()
      .subscribe(isEnabled => {
        this.isShow = isEnabled;
      });
  }

  ngOnDestroy() {
    this.siteNavMenuService.show();
    this.siteNavMenuSubscription.unsubscribe();
  }

  onToggle() {
    this.isShow ? this.siteNavMenuService.hide() : this.siteNavMenuService.show();
  }

}
